import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Code } from '@material-ui/icons';
import cx from 'classnames';
import Autosuggest from 'react-autosuggest';
import { motion, AnimatePresence } from 'framer-motion';
import { NODES, SNIPPETS } from '../../../constants';
import { EventEmitter } from '../../../utils';
import PopupWrapper from '../../PopupWrapper';

class Snippets extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      suggestions: [],
      snippetSuggestionValue: '',
    };

    this.getSuggestions = this.getSuggestions.bind(this);
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(
      this
    );
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(
      this
    );
    this.onSnippetSuggestionChange = this.onSnippetSuggestionChange.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    this.insertSnippet = this.insertSnippet.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
  }

  componentDidMount() {
    EventEmitter.listen('open-popup--snippet', () => {
      this.togglePopup();
    });
  }

  getSuggestions(value) {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    return inputLength === 0
      ? []
      : SNIPPETS.filter(article => {
          return article.title.toLowerCase().includes(inputValue);
        });
  }

  getSuggestionValue(suggestion) {
    return suggestion.value;
  }

  renderSuggestion(suggestion) {
    return <div>{suggestion.title}</div>;
  }

  onSuggestionsFetchRequested({ value }) {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  }

  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] });
  }

  onSnippetSuggestionChange(event, { newValue }) {
    this.setState({ snippetSuggestionValue: newValue });
  }

  togglePopup() {
    this.setState(prevState => ({ showPopup: !prevState.showPopup }));
  }

  insertSnippet(event) {
    event.preventDefault();
    this.props.editor.insertBlock({
      type: NODES.SNIPPET,
      data: { snippetName: this.state.snippetSuggestionValue },
    });

    this.togglePopup();
    this.setState({ suggestions: [], snippetSuggestionValue: '' });
  }

  onSuggestionSelected(event) {
    // adding this to avoid auto close of popups
    event.stopPropagation();
  }

  render() {
    const autoSuggestInputProps = {
      placeholder: 'Enter snippet name to search',
      value: this.state.snippetSuggestionValue,
      onChange: this.onSnippetSuggestionChange,
      className: 'link__input normal-border-sm w-48 rounded-sm p-1',
    };
    const disableSubmitButton = !this.state.snippetSuggestionValue.trim();
    return (
      <PopupWrapper
        isOpen={this.state.showPopup}
        togglePopup={this.togglePopup}>
        <span className="icon__wrapper icon__wrapper--snippet">
          <button
            title="Snippet"
            className={cx('icon__button', {
              active: this.state.showPopup,
            })}
            onClick={this.togglePopup}>
            <Code />
          </button>
          <AnimatePresence>
            {this.state.showPopup && (
              <motion.div
                initial={{ opacity: 0, y: '80%' }}
                animate={{ opacity: 1, y: '100%' }}
                exit={{ opacity: 0, y: '80%' }}
                transition={{ ease: [0.18, 0.89, 0.39, 1.4], duration: 0.3 }}
                className="icon__popup icon__popup--snippet icon__popup--with_autosuggest">
                <label className="text-sm font-bold flex just-between items-center whitespace-no-wrap mb-5">
                  Snippet
                  <Autosuggest
                    alwaysRenderSuggestions
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={
                      this.onSuggestionsFetchRequested
                    }
                    onSuggestionsClearRequested={
                      this.onSuggestionsClearRequested
                    }
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={autoSuggestInputProps}
                    onSuggestionSelected={this.onSuggestionSelected}
                  />
                </label>
                <div>
                  <button
                    className={cx(
                      'normal-button rounded p-1 font-bold cursor-pointer w-full',
                      { disable: disableSubmitButton }
                    )}
                    onClick={this.insertSnippet}>
                    Add Snippet
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </span>
      </PopupWrapper>
    );
  }
}

export default  Snippets;
